import { useScaffold } from "@Light/scaffold";
import { formatOnScheduleRate } from "@Light/utils/evProgram";
import { usePlan } from "@Light/utils/plan";
import clsx from "clsx";

export type IntervalLegendProps = {};

export const IntervalLegend: React.FC<IntervalLegendProps> = ({}) => {
  const plan = usePlan();
  const { solarBuyback, vehicleCharging } = plan.features;
  const hasSolarBuyback = Boolean(solarBuyback);
  const hasVehicleCharging = Boolean(vehicleCharging);
  if (!hasSolarBuyback && !hasVehicleCharging) {
    return null;
  }
  const rate = vehicleCharging
    ? formatOnScheduleRate(vehicleCharging.onScheduleRates)
    : undefined;
  return (
    <div className="flex justify-center">
      <div className="flex flex-row gap-6">
        <Item label={hasSolarBuyback ? "Import" : "Home"} color="#8ED1D9" />
        {hasSolarBuyback && (
          <>
            <Item label="Export" color="rgb(253 224 71)" />
          </>
        )}
        {hasVehicleCharging && (
          <>
            <Item
              label={rate ? `Vehicle charging (${rate})` : "Vehicle charging"}
              color="#1570EF"
            />
            <Item label="Vehicle charging (normal rate)" color="#C07A79" />
          </>
        )}
      </div>
    </div>
  );
};

export type ItemProps = {
  label: string;
  color: string;
};

export const Item: React.FC<ItemProps> = ({ label, color }) => {
  const scaffold = useScaffold();
  return (
    <div className="flex flex-row gap-2 items-center">
      <div className="w-2 h-2" style={{ background: color }} />
      <div className={clsx("text-2xs", scaffold.page.colors.text.tertiary)}>
        {label}
      </div>
    </div>
  );
};
